<template>
	<div style="padding: 0 20px 50px 20px;" class="enterBox">
		<div class="operation-box f-cb">
			<!-- <el-button type="primary" class="f-fl" style="margin-right:20px ;" @click="$router.push({ path: 'productregister' })"> 码标注册</el-button> -->
			<el-select v-model="select" slot="prepend" placeholder="请选择" class="f-fl" style="width: 26%" @change="section">
				<el-option v-for="item in selectfata" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-input placeholder="请输入内容" @keyup.enter.native="inquire" v-model.trim="precisecontext" class="input-with-select" style="width: 50%;">
				<el-button slot="append" icon="el-icon-search" @click="inquire"></el-button>
			</el-input>
		</div>
		<section class="result-box">
			<el-table :data="tableData" style="width: 100%;min-height: 480px;" v-loading="Loading" >
				<el-table-column prop="yardImg" label="码图" > 
					<template slot-scope="scope">
						<img src="../assets/imgs/pic02.jpg" alt="码图" style="width: 50px;cursor: pointer;" @click="yardIncident(scope.row)" />
					</template>
				</el-table-column>
				<el-table-column prop="name" label="码标">
				</el-table-column>
				<el-table-column prop="analysis" label="解析IDcode " v-if="false">
				</el-table-column>
				<el-table-column prop="starttime" label="注册有效期" min-width="160px"     align="center" >
				</el-table-column>
				<!--<el-table-column prop="endtime" label="到期时间 " >
				</el-table-column>-->
				<el-table-column prop="registrationtime" label="注册时间 ">
				</el-table-column>
				<!-- <el-table-column prop="examineStatusRemark" label="资料状态 ">
				</el-table-column> -->
				<el-table-column prop="state" label="码标状态 ">
				</el-table-column>
				<!--<el-table-column prop="userState" label="用户状态 ">
				</el-table-column>-->
				<el-table-column prop="analysisState" label="解析状态 ">
				</el-table-column>
				<el-table-column prop="type" label="操作 " min-width="300px" header-align="center" >
					<template slot-scope="scope">
						<!--{{scope.row.operationList}}-->
						<!--<el-button type="text" size="mini" @click="analysisEvent({row:scope.row}) ">设置解析</el-button>-->

						<el-button size="mini" v-for="(item,index) in scope.row.operationList" plain style="margin-top: 10px;margin-left: 0;margin-right: 10px;" :type="item.isGray?'info':'primary'" @click="handleDelete(scope.$index, scope.row,item.operationType,item.isGray)" :key="index">{{item.operation}}</el-button>
						<!--<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
					</template>
				</el-table-column>
				<el-table-column prop="" label="查看详情 ">
					<template slot-scope="scope">
						<el-button type="text" size="mini" @click="particulars(scope.row.id)">查看详情</el-button>

					</template>

				</el-table-column>
			</el-table>
		</section>

		<div class="pagination-box">
			<el-pagination background layout="prev, pager, next,slot,total,sizes" :total="pagination.total" :page-size="10" prev-text=" 上一页 " :page-sizes="[10]" next-text="下一页" @prev-click="prev" @next-click="next" @current-change="current">

			</el-pagination>
		</div>
		<el-dialog title="请完善相关信息" :visible.sync="dialogVisible" width="40%">

			<el-form ref="form" :model="form" label-width="120px" :rules="rules" style="text-align: left;">
				<el-form-item label="姓名：" prop="name">
					<el-input v-model.trim="form.name" style="width: 50%;"></el-input>
				</el-form-item>
				<!--<el-form-item label="证件类型：" prop="idtype">
					<el-select v-model="form.idtype.present" placeholder="请选择">
						<el-option v-for="(item,index) in form.idtype.data" :label="item.label" :key="index" :value="item.value"></el-option>
					</el-select>

				</el-form-item>
				<el-form-item label="护照号码：" prop="Unifiedsocialcredit" v-if="form.idtype.present === 2">
					<el-input v-model.trim="form.Unifiedsocialcredit" placeholder="请填写护照号码"></el-input>
				</el-form-item>
				<el-form-item label="身份证号码：" prop="Unifiedsocialcredit" v-else>
					<el-input v-model.trim="form.Unifiedsocialcredit" placeholder="请填写身份证号码"></el-input>
				</el-form-item>-->
			</el-form>
			<span slot="footer" class="dialog-footer">
<!--		    <el-button @click="dialogVisible = false">取 消</el-button>-->
		    <el-button type="primary" @click="userDataGenerate">确 定</el-button>
		  </span>

		</el-dialog>
		<el-dialog title="证书" :visible.sync="Imgshow" width="600px">
			<div v-loading="ImgLoading" class="imagealert">
				<img :src='imgurl' style="width: 100%; display: inline-block;"></img>
			</div>
		</el-dialog>

		<!--解析-->
		<el-dialog title="请填写解析地址" :visible.sync="analysisShow" width="40%">
			<el-input style="width: 80%;" placeholder="请填写解析地址" v-model="analysisCon"></el-input>
			<span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="analysisSubmit">确 定</el-button>
		  </span>

		</el-dialog>

		<el-dialog title="码图下载" :visible.sync="yardImgshow" width="600px">

			<div class="f-cb" v-loading="yardloading" style="text-align: center;">
				<!--@click="recycle(item.picUrl) "-->
				<div style="width: 100px; margin-left: 10px;cursor: pointer;" class="f-fl" v-for="(item,index) in  yardImgs" :key="index">
					<img style="width: 100%;" :src="item.picUrl" />
					<el-button type="text" @click="recycle({url:item.picUrl,type:item.picName})">{{item.picName}}</el-button>
				</div>

			</div>
			<span slot="footer" class="dialog-footer"></span>
		</el-dialog>

	</div>
</template>

<script>
	import { Loading } from 'element-ui';
	import debounce from "lodash/debounce";

	export default {
		data() {
			var numberVerification = (rule, value, callback) => {
				if(this.form.idtype.present === '') {
					callback(new Error('请先选择证件类型'));

				} else {
					if(value === '') {
						callback(new Error('请填写证件号码'));

					} else {
						if(this.form.idtype.present == 1) {
							if(/^(^[1-9]\d{7}((02[0-2]\d)|((01|03|05|07|08|10|12)(([0-2]\d)|3[0-1]))|((04|06|09|11)(([0-2]\d)|30)))\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((02[0-2]\d)|((01|03|05|07|08|10|12)(([0-2]\d)|3[0-1]))|((04|06|09|11)(([0-2]\d)|30)))((\d{4})|\d{3}[Xx])$)$|(^((\s?[A-Za-z])|([A-Za-z]{2}))\d{6}(([0−9aA])|([0-9aA]))$)|(^[1|5|7][0-9]{6}[0-9A-Z]$)|(^[A-KM-QT-XZ]{1}[0-9]{9}$)/.test(value)) {
								callback();
							} else {
								callback(new Error('身份证号码格式不正确，请重新填写'));

							}
						}

						if(this.form.idtype.present == 2) {
							if(!/^((1[45]\d{7})|(G\d{8})|(P\d{7})|(S\d{7,8}))?$/.test(value)) {

								callback(new Error('护照号码格式不正确，请重新填写'));

							} else {

								callback();

							}
						}

					}
				}

			}
			var idtypePass = (rule, value, callback) => {
				if(value.present === '') {
					callback(new Error('请选择证件类型'));

				} else {
					callback();
				}
			};
			return {
				presentROw: {},
				yardImgshow: false,
				yardImgs: [],
				yardloading: false,
				analysisShow: false,
				analysisCon: '',
				imgurl: '',
				dialogVisible: false,
				ImgLoading: false,
				Imgshow: false,
				form: {
					name: '',
					idtype: {
						present: '',
						data: [{
								value: 1,
								label: '身份证'
							},
							{
								value: 2,
								label: '护照'
							}
						]

					},
					Unifiedsocialcredit: '',

				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}, ],
					idtype: {
						required: true,

						validator: idtypePass,
						trigger: 'blur'

					},
					Unifiedsocialcredit: {
						required: true,

						validator: numberVerification,
						trigger: 'blur'

					}
				},
				presentID: '',
				Loading: false,
				precisecontext: '',
				select: 'all',
				selectfata: [{
						value: 'all',
						label: '全部'
					},
					{
						value: '-7',
						label: '限制词审核失败已停用'
					},
					{
						value: 100,
						label: '审核通过'
					}, {
						value: '-6',
						label: '审核期退款已停用'
					}, {
						value: '-5',
						label: '未续费已停用'
					}, {
						value: '-4',
						label: '未缴费已停用'
					}, {
						value: '-3',
						label: '已禁用'
					}, {
						value: '-2',
						label: '已过期'
					}, {
						value: 2,
						label: '注册待付款'
					}, {
						value: 4,
						label: '已过户'
					}, {
						value: 99,
						label: '审核期'
					},
					{
						value: 88,
						label: '限制词审核期'
					},

				],
				tableData: [],

				pagination: {
					total: 0,
					present: 1,

				},
				MaImgsType: new Map([
					['下载QR码', [1, 'IndexPage']],
					['下载汉信码', [4, 'FailPage']],
					['下载龙贝码', [2, 'FailPage']],
					['下载GM码', [5, 'SuccessPage']],
					['下载DM码', [3, 'CancelPage']],
					['default', ['other', 'Index']]
				])
			}
		},
		created() {
			this.Datas();
		},
		methods: {
			yardIncident(row) {
				this.presentROw = row
				this.yardImgshow = this.yardloading = true;
				this.$http.get(this.$api + '/identificationApply/showIdentificationCodeImage', {
					params: {
						identificationID: row.id
					}
				}).then(res => {
					if(res.body.result === 1) {
						this.yardImgs = res.body.entity;
					} else {
						this.$message.error(res.body.message);

					}
					this.yardloading = false;

				})
			},
			recycle({
				url,
				type
			}) {
				//				const actions = new Map([
				//					['下载QR码', [1, 'IndexPage']],
				//					['下载汉信码', [4, 'FailPage']],
				//					['下载龙贝码', [2, 'FailPage']],
				//					['下载GM码', [5, 'SuccessPage']],
				//					['下载DM码', [3, 'CancelPage']],
				//					['default', ['other', 'Index']]
				//				])
				const onButtonClick = (status) => {
					let action = this.MaImgsType.get(status) || this.MaImgsType.get('default')
					return action[0]

				}
				//console.log('/api/categoryApply/ZipDownloads?filePath=CreateCode&codeType=' + onButtonClick(type) + '&objectCode=码标&unitId=' + this.$store.state.commonalityData.IdcodeUserId + '&isMB=2')
				window.location.href = '/api/categoryApply/ZipDownloads?filePath=CreateCode&codeType=' + onButtonClick(type) + '&objectCode=' + this.presentROw.name + '&unitId=' + this.$store.state.commonalityData.IdcodeUserId + '&isMB=1';

				//				window.location.href = url;
				//window.location.href='/api/categoryApply/ZipDownloads?filePath=CreateCode&codeType=' + imgData.type+ '&objectCode=码标'&unitId=' + $store.state.commonalityData.IdcodeUserId+ '&isMB=2';

			},
			analysisSubmit() {
				let {
					analysisCon
				} = this;
				if(!analysisCon) {
					this.$message.error('请填写解析地址');

				} else {
					if(/^((http(s)?):\/\/)?(((\w(\-*\w)*\.)+[a-zA-Z]{2,4})|(((1\d\d|2([0-4]\d|5[0-5])|[1-9]\d|\d).){3}(1\d\d|2([0-4]\d|5[0-5])|[1-9]\d|\d).?))(:\d{0,5})?(\/+.*)*$/.test(analysisCon)) {
						this.$http.post(this.$api + '/identificationApply/identificationSetGotourl', {
							identificationID: this.presentID,
							gotourl: analysisCon
						}).then(res => {
							if(res.body.result === 1) {
								this.$message({
									message: '解析成功',
									type: 'success'
								});
								this.Datas();
							} else {
								this.$message.error(res.body.message);

							}
						})
						this.analysisShow = false;
					} else {
						this.$message.error('地址格式不正确,请重新填写');
					}

				}

			},
			Datas() {
				this.Loading = true;
				this.$http.get(this.$api + '/identificationApply/getIdentificationListByPage', {
					params: {
						identification: this.precisecontext,
						identificationStatus: this.select,
						pageIndex: this.pagination.present,
						pageSize: '10'
					}
				}).then(res => {
					if(res.body.result === 1) {
						this.pagination.total = res.body.entity.totalElements;
						this.tableData = res.body.entity.content.map((item, index) => {

							return {
								name: item.identification,
								analysis: item.analyIDcode,
								starttime: item.regEffectiveTime,
								registrationtime: item.createDate,
								state: item.statusRemark,
								userState: item.unitStatusRemark,
								id: item.identification_ID,
								//							type: item.operationType,
								//							typename:item.operation,
								//								yardImg: item.entity,
								examineStatusRemark:item.examineStatusRemark,
								analysisState: item.gotourlStatusRemark,
								url: item.gotourl,
								operationList: item.operationList,
								payment_order: item.payment_order
							}

						})
					} else {
						this.tableData = [];
						this.pagination.total = 0;
					}
					this.Loading = false;
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');

				})

			},
			handleDelete(index, row, type, isGray) {
				this.presentID = row.id;
				//				this.presentROw=row
				//								console.log(isGray)
				if(!isGray) {
					switch(type) {
						case 1:
							this.$router.push({
								path: 'perfect',
							})
							break;
						case 2:
							this.$router.push({
								path: 'indent',
								query: {
									indentId: row.payment_order
								}
							})
							break;
						case 3:
							this.$router.push({
								path: 'renew',
								query: {
									name: row.name,
									type: 2,
									id: row.id
								}
							})
							break;
						case 4:
							this.$router.push({
								path: 'indent',
								query: {
									indentId: row.payment_order
								}
							})
							break;
						case 5:
							this.$router.push({
								path: 'thetransfer',
								query: {
									id: row.id
								}
							})
							break;
						case 6:
							this.certificate(row.id)
							break;
						case 7:
							this.$router.push({
								path: 'renew',
								query: {
									name: row.name,
									type: 0,
									id: row.id
								}
							})
							break;
						case 8:
							this.analysisShow = true;
							this.analysisCon = row.url;
							break;
						case 9:
							this.$router.push({
								path: 'dataSubmitted',
								query: {
									id: row.id
								}
							})
							break;
					}

				}
				//				if(type === 1) {
				//					this.$router.push({
				//						path: 'perfect',
				//					})
				//				} else if(type === 2) {
				//					this.$router.push({
				//						path: 'indent',
				//						query: {
				//							indentId: row.payment_order
				//						}
				//					})
				//				} else if(type === 3) {
				//					this.$router.push({
				//						path: 'renew',
				//						query: {
				//							name: row.name,
				//							type: 2,
				//							id: row.id
				//						}
				//					})
				//				} else if(type === 4) {
				//					this.$router.push({
				//						path: 'indent',
				//						query: {
				//							indentId: row.payment_order
				//						}
				//					})
				//				} else if(type === 5) {
				//					this.$router.push({
				//						path: 'thetransfer',
				//						query: {
				//							id: row.id
				//						}
				//					})
				//				} else if(type === 6) {
				//					this.certificate(row.id)
				//
				//				} else if(type === 7) {
				//					this.$router.push({
				//						path: 'renew',
				//						query: {
				//							name: row.name,
				//							type: 0,
				//							id: row.id
				//						}
				//					})
				//
				//				} else if(type === 8) {
				//					this.analysisShow = true;
				//					this.analysisCon = row.url;
				//
				//				}

			},

			certificate(id) {
				this.Imgshow = true;
				this.ImgLoading = true;
				this.$http.post(this.$api + '/identificationApply/showCertificate', {
					identificationID: id
				}).then(res => {
					if(res.body.result === 0) {
						this.Imgshow = false;
						this.ImgLoading = false;
						this.dialogVisible = true;
					} else if(res.body.result === 1) {
						this.imgurl = res.body.entity.certificateUrl;
						//							
						//						});
						this.ImgLoading = false;

					} else {
						this.$message.error(res.body.message);
					}
				})
			},
			userDataGenerate() {
				this.$refs.form.validate((valid) => {
					if(valid) {
						this.dialogVisible = false;
						this.Imgshow = true;
						this.ImgLoading = true;
						let {
							form
						} = this;
						this.$http.post(this.$api + '/identificationApply/insertMBUserUnitInfo', {
							userName: form.name,
							//							IDType: form.idtype.present,
							//							IDNumber: form.Unifiedsocialcredit,
							identificationID: this.presentID,
						}).then(res => {
							if(res.body.result === 1) {

								this.imgurl = res.body.entity.certificateUrl;
								this.ImgLoading = false;

							} else {
								this.Imgshow = false;
								this.dialogVisible = true;

								this.$message.error(res.body.message);

							}
						}, rej => {
							this.Imgshow = false;
							this.dialogVisible = false;

						})
					} else {
						//						this.$message.error('填写信息有误，请检查后重新提交。');
					}

				})

			},
			prev(val) {
				//				console.log(val)
				this.pagination.present = val;
				this.Datas();

			},
			next(val) {
				//				console.log(val)
				this.pagination.present = val;
				this.Datas();

			},
			current(val) {
				this.pagination.present = val;
				this.Datas();
			},
			inquire: debounce(function() {

				this.Datas();

			}, 200),
			particulars(id) {
				this.$router.push({
					path: 'enterprisembdetails',
					query: {
						id: id
					}
				})
			},
			section() {
				this.pagination.present = 1;

				this.Datas();

			}
		}
	}
</script>

<style lang="scss">
	.operation-box {
		/*border: solid red 1px;*/
		width: 60%;
		/*text-align: left;*/
		/*margin: 0 auto;*/
		margin-top: 50px;
	}
	
	.result-box {
		/*border: solid red 1px;*/
		padding-top: 40px;
	}
	
	.pagination-box {
		margin-top: 50px;
	}
	
	.imagealert {
		/*width: 600px !important;*/
		/*height: 80%;*/
		/*height: 800px;*/
		overflow: hidden;
		/*border: solid red 1px;*/
		height: 500px;
		overflow-y: scroll !important;
		img {
			width: 100%;
			display: inline-block;
		}
	}
	/*.certificateimg{
		width: 200px;
			display: inline-block;
		
	}*/
	
	.dialog-footer {
		display: inline-block;
		width: 100%;
		text-align: center;
	}
	.enterBox{
		.el-table__body-wrapper{
			min-height:480px;
		}
	}
</style>